// Starea programării lecțiilor (vine din backend, /booking-monitor/statuses):
//  - PENDING  (galben): în cele 5 zile în care elevul primește mementouri;
//  - BOOKED   (verde):  s-a programat;
//  - OVERDUE  (roșu):   nu s-a programat după 5 zile / pachetul s-a terminat
//                       fără următoarea programare — managerul îl sună.

export const BOOKING_STATUS_FILTERS = [
   { value: "PENDING", label: "În așteptare", tone: "pending" },
   { value: "BOOKED", label: "Programați", tone: "booked" },
   { value: "OVERDUE", label: "Necesită atenție", tone: "overdue" },
];

export function bookingStatusTone(state) {
   if (!state) return null;
   if (state.status === "PENDING") return "pending";
   if (state.status === "BOOKED") return "booked";
   if (state.status === "OVERDUE") return "overdue";
   return null;
}

/** Un cuvânt pe butonul de copiere din listă: starea, pe culoarea ei. */
export function bookingStatusShortLabel(state) {
   if (!state) return "";
   if (state.status === "OVERDUE") return "Întârziat";
   if (state.status === "BOOKED") return "Programat";
   if (state.status === "PENDING") return "În așteptare";
   return "";
}

/** Eticheta scurtă din cardul elevului. */
export function bookingStatusLabel(state) {
   if (!state) return "";
   if (state.status === "BOOKED") return "Programat";
   if (state.status === "OVERDUE") {
      return state.stage === "NEXT_PACKAGE" ? "Pachet încheiat" : "Neprogramat";
   }
   if (state.stage === "NEXT_PACKAGE") {
      const d = Number(state.daysLeft) || 0;
      return d <= 1 ? "Final pachet: mâine" : `Final pachet: ${d} zile`;
   }
   const day = Number(state.day) || 0;
   return day <= 0 ? "Acces deschis azi" : `Ziua ${day} din 5`;
}

/** Explicația din tooltip. */
export function bookingStatusTitle(state) {
   if (!state) return "";
   if (state.status === "BOOKED") return "Elevul are lecții programate.";
   if (state.status === "OVERDUE") {
      return state.stage === "NEXT_PACKAGE"
         ? "Necesită atenție: pachetul de 15 lecții s-a terminat, iar următoarele nu sunt programate. Sunați elevul."
         : "Necesită atenție: nu s-a programat la nicio lecție în 5 zile de la deschiderea accesului. Sunați elevul.";
   }
   return state.stage === "NEXT_PACKAGE"
      ? "Se apropie finalul pachetului de 15 lecții; elevul primește zilnic mementouri în chat."
      : "Elevul încă nu s-a programat; primește zilnic mementouri în chat (5 zile).";
}

/** Map userId -> stare, din răspunsul backend-ului. */
export function indexBookingStatuses(payload) {
   const map = new Map();
   for (const row of payload?.statuses || []) {
      if (row && row.userId != null) map.set(String(row.userId), row);
   }
   return map;
}
